import styled from 'styled-components';

import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;

    ${screenBiggerThan(Screen.mobile)} {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
    }
`;

export const Title = styled.div`
    width: 100%;
    height: 32px;
    padding: 15px 15px 0;
    background: ${({ theme }) => theme.functionColor.function0};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    ${screenBiggerThan(Screen.mobile)} {
        display: none;
    }

    > span {
        color: ${({ theme }) => theme.functionColor.function100};
        font-size: 1.4rem;
        line-height: 1.4;
        font-weight: 700;
        flex: 1 1 auto;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
    }
`;
